import React, { useContext } from "react";
import { StyleSheet, View, TouchableOpacity, Platform } from "react-native";
import { useState } from "react";
import {
  InputBox,
  IconButton,
  DMCImage,
  context,
} from "../accessories/accessories.js";
import {
  FormatPhoneLogin,
  handleAPI,
  handleCreateNewSession,
  handleOpenURL,
  log,
} from "../accessories/CommonFunctions.js";
import CustomText from "../accessories/CustomText.js";
import Icon from "react-native-vector-icons/AntDesign";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import Checkbox from "expo-checkbox";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ScrollContainer from "../accessories/ScrollContainer.js";
import { REDIRECT_URL } from "@env";
import ArrowSpinner from "../accessories/ArrowSpinner.js";
import useKeyboardHeight from "../accessories/KeyboardHeight.js";
import { ios } from "../accessories/Platform.js";

let email = "",
  cellPhone = "";

export default function Signup(props) {
  const { navigation, route = {}, from = "", performAction = null } = props;
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { params = {} } = route;
  const userName = params ? params.userName || "" : "";
  const { deviceId = "", loginType = "" } = params || {};

  if (userName.indexOf("@") === -1 && Number(userName) > 0) {
    cellPhone = userName
      .replaceAll("-", "")
      .replaceAll("(", "")
      .replaceAll(")", "")
      .replaceAll(" ", "");
  } else {
    email = userName;
  }
  const [errorMsg, setErrorMsg] = useState({
    text: "",
    color: "red",
  });
  const [emailSentTo, setEmailSentTo] = useState(null);
  const [errorMessage, setErrorMessage] = useState({
    text: "",
    color: "red",
  });
  const [currentPage, setCurrentPage] = useState("signUp"); //signUp
  const [isRemember, setIsRemember] = useState(false);
  const [userType, setUserType] = useState({
    mortgageEmployee: false,
    borrower: false,
    vendor: false,
  });
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [newIsPasswordSecure, setNewIsPasswordSecure] = useState({
    password: !false,
    confirmPassword: !false,
  });
  const [PasswordMisMatch, setPasswordMisMatch] = useState("");
  const [newPasswordMessage, setNewPasswordMessage] = useState({
    passwordMsg: "",
    confirmPasswordMsg: "",
  });
  const [headerText, setHeaderText] = useState(
    `~~~Your ${
      userName.indexOf("@") === -1 ? "Cell Phone" : "Email Address"
    } is not recognized. To create an account, enter your contact information or click the Back link to try again`
  );
  const [signUpDetails, setSignUpDetails] = React.useState({
    firstName: "",
    lastName: "",
    cellPhone: cellPhone,
    formatedCellPhone: FormatPhoneLogin(cellPhone),
    email: email,
    enteredAccessCode: "",
  });
  const [processingStatus, setProcessingStatus] = useState(null);
  const [validateSignUp, setValidateSignUp] = React.useState({
    firstName: false,
    lastName: false,
    cellPhone: false,
    email: false,
  });
  const [webPageURL, setWebPageURL] = useState(null);
  const [accesscodeWarningMsg, setAccesscodeWarningMsg] = useState(null);

  const handleSetStoredCredential = (signDetails) => {
    let { WebLoginId, firstName, lastName, cellPhone, email } = signDetails;

    let objectToStore = JSON.stringify({
      WebLoginId: WebLoginId,
      UserDisplayName: `${firstName} ${lastName}`,
      URL: "BorrowerWelcome",
      UserName: email || cellPhone,
      AutoRedirectExpiryDate: getExpireDate(60), //in Minutes
      AutoRedirect: true,
    });
    AsyncStorage.removeItem("Credentials");
    AsyncStorage.setItem("Credentials", objectToStore || null);
  };
  const getExpireDate = (expireInMinutes) => {
    const now = new Date();
    let expireTime = new Date(now);
    expireTime.setMinutes(now.getMinutes() + expireInMinutes);
    return expireTime.getTime();
  };
  const navigate = (path, option) => {
    if (performAction) {
      performAction(path, option);
    } else {
      navigation.navigate(path, option || {});
    }
  };
  const handleClearState = () => {
    setTimeout(() => {
      setProcessingStatus(null);
      setErrorMsg({ ...errorMsg, text: "" });
      setEmailSentTo("");
      setCurrentPage("signUp");
      setUserType({
        mortgageEmployee: false,
        borrower: false,
        vendor: false,
      });
      setNewPassword({
        password: "",
        confirmPassword: "",
      });
      setNewIsPasswordSecure({
        password: false,
        confirmPassword: false,
      });
      setNewPasswordMessage({
        passwordMsg: "",
        confirmPasswordMsg: "",
      });
      setHeaderText(
        `~~~Your ${
          userName.indexOf("@") === -1 ? "Cell Phone" : "Email Address"
        } is not recognized. To create an account, enter your contact information or click the Back link to try again`
      );
      setSignUpDetails({
        firstName: "",
        lastName: "",
        cellPhone: cellPhone,
        formatedCellPhone: FormatPhoneLogin(cellPhone),
        email: email,
        enteredAccessCode: "",
      });
    }, 1000);
  };
  const handleChange = (event) => {
    let { name, value, isFormat } = event,
      obj = { [name]: value };
    // if (name === "cellPhone" && value !== "") {
    //   value = value
    //     .replaceAll("-", "")
    //     .replaceAll("(", "")
    //     .replaceAll(")", "")
    //     .replaceAll(" ", "");
    // }
    if (isFormat)
      obj = { [name]: value, formatedCellPhone: FormatPhoneLogin(value) };
    else if (name === "cellPhone")
      obj = { [name]: value, formatedCellPhone: value };

    setSignUpDetails({ ...signUpDetails, ...obj });
  };
  const handleSubmit = () => {
    let { firstName, lastName, cellPhone, email } = signUpDetails;
    if (
      firstName === "" ||
      lastName === "" ||
      cellPhone === "" ||
      email === ""
    ) {
      setValidateSignUp({
        ...validateSignUp,
        ...{
          firstName: firstName === "",
          lastName: lastName === "",
          cellPhone: cellPhone === "",
          email: email === "",
        },
      });
      setErrorMsg({
        text: "Please make an entry in all required fields.",
        color: "#999",
      });
      return false;
    } else {
      setErrorMsg({
        text: "",
      });
    }
    setProcessingStatus("Submit");
    let obj = `<root><row IsValidCode="0" FName="${firstName}" LName="${lastName}" CellPhone="${cellPhone}" EmailAddress="${email}" ShortCode="" Utype="" WhatFor="" LoanOfficerId="0" OrgUrl="Mobile Application"/></root>`;

    handleAPI({
      name: "CheckSignUpDetailsLoginWeb",
      params: { CustDetails: obj },
    }).then((response) => {
      response = JSON.parse(response)["Table"][0];
      response = { ...signUpDetails, ...response };
      setSignUpDetails(response);
      handleCreateAccessCode(response);
    });
  };
  const handleEmailSentTo = (value) => {
    setEmailSentTo(value);
    setTimeout(() => {
      setEmailSentTo(null);
    }, 2000);
  };
  const handleCreateAccessCode = (signDetails, accessCodeFlag) => {
    signDetails = signDetails || signUpDetails;
    let reff = accessCodeFlag;
    //Sending Access Code for Both Email & Cellphone
    if (reff === undefined) {
      reff = 3;
    }
    let { GatherId } = signDetails;
    handleAPI({
      name: "CreateAccessCode",
      params: { GatherId: GatherId, Ref: reff },
    }).then((response) => {
      handleEmailSentTo(reff);
      response = response.split("|");
      if (response.length > 2) {
        let msg = "";
        if (Number(response[3]) === 0) msg = response[1];
        setAccesscodeWarningMsg(msg);
        signDetails = { ...signDetails, AccessCode: response[2] };
        signDetails = { ...signDetails, ...signUpDetails };
        signDetails = { ...signDetails, GatherId: GatherId };
        setSignUpDetails(signDetails);
        setHeaderText(
          "~~~We've sent a code to both your email and cell phone. Enter it below."
        );
        setCurrentPage("accessCode");
      }
    });
  };
  const validatePassword = (key, text) => {
    setNewPassword({ ...newPassword, [key]: text });
    let strength = 0;
    if (text.length > 6) strength += 1;
    if (text.match(/([A-Z])/) && text.match(/([0-9])/)) strength += 1;
    if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
    let msg = ``;
    if (strength < 3) {
      msg = `Password does not meet complexity Requirements.`;
    } else {
      msg = `Password Meets Complexity Requirements`;
    }
    if (key === "confirmPassword" && text !== newPassword["password"]) {
      msg = `Password Does Not Match`;
      strength = 0;
    }
    msg = (
      <View>
        <FontAwesome
          name={strength < 3 ? "close" : "check"}
          size={22}
          color={strength < 3 ? "red" : "green"}
        />

        <CustomText
          bold={true}
          style={{
            color: "#999",
            marginTop: -25,
            marginBottom: 20,
            fontSize: 14,
            marginLeft: 30,
          }}
        >
          {msg}
        </CustomText>
      </View>
    );

    if (
      key === "password" &&
      text !== newPassword["confirmPassword"] &&
      newPassword["confirmPassword"]?.length > 0
    ) {
      setNewPasswordMessage((prevNewPasswordMessage) => ({
        ...prevNewPasswordMessage,
        confirmPasswordMsg: (
          <View>
            <FontAwesome name="close" size={22} color="red" />

            <CustomText
              bold={true}
              style={{
                color: "#999",
                marginTop: -25,
                marginBottom: 20,
                fontSize: 14,
                marginLeft: 30,
              }}
            >
              Password Does Not Match
            </CustomText>
          </View>
        ),
      }));
    } else if (
      key === "password" &&
      text === newPassword["confirmPassword"] &&
      newPassword["confirmPassword"]?.length > 0
    ) {
      setNewPasswordMessage((prevNewPasswordMessage) => ({
        ...prevNewPasswordMessage,
        confirmPasswordMsg: (
          <View>
            <FontAwesome name="check" size={22} color="green" />

            <CustomText
              bold={true}
              style={{
                color: "#999",
                marginTop: -25,
                marginBottom: 20,
                fontSize: 14,
                marginLeft: 30,
              }}
            >
              Password Meets Complexity Requirements
            </CustomText>
          </View>
        ),
      }));
    }

    setNewPasswordMessage((prevNewPasswordMessage) => ({
      ...prevNewPasswordMessage,
      [`${key}Msg`]: msg,
    }));
  };
  const getSecureEmail = () => {
    let Email = "";
    if (
      signUpDetails["email"] === "" ||
      signUpDetails["email"].indexOf("@") === -1
    ) {
      return <></>;
    } else Email = signUpDetails["email"].split("@");
    return (
      <>
        <CustomText
          onPress={() => {
            handleCreateAccessCode(signUpDetails, 1);
          }}
          bold={true}
          style={[styles.footText, { alignSelf: "flex-start", fontSize: 13 }]}
        >
          Resend via email
        </CustomText>
        <CustomText
          bold={true}
          style={{ fontSize: 13, color: "#999", marginTop: 5 }}
        >
          {`${Email[0].slice(0, 2)}...${Email[1]}`}
        </CustomText>
        {emailSentTo === 1 ||
          (emailSentTo === 3 && (
            <CustomText bold={true} style={{ color: "#0000ff", fontSize: 12 }}>
              Sent
            </CustomText>
          ))}
      </>
    );
  };
  const getSecurePhone = () => {
    let Phone = signUpDetails["cellPhone"];
    if (Phone === undefined) {
      if (
        Number(signUpDetails["email"]) !== NaN &&
        signUpDetails["email"].indexOf("@") === -1
      ) {
        Phone = signUpDetails["email"];
      }
    } else Phone = Phone.slice(-4);
    return (
      <>
        {Phone === "" ? (
          <></>
        ) : (
          <>
            <CustomText
              onPress={() => {
                handleCreateAccessCode(signUpDetails, 2);
              }}
              bold={true}
              style={[
                styles.footText,
                { alignSelf: "flex-start", fontSize: 13 },
              ]}
            >
              Resend via text message
            </CustomText>
            <CustomText
              bold={true}
              style={{ fontSize: 13, color: "#999", marginTop: 5 }}
            >
              {`xxx-xxx-${Phone}`}
            </CustomText>
            {emailSentTo === 2 ||
              (emailSentTo === 3 && (
                <CustomText
                  bold={true}
                  style={{ color: "#0000ff", fontSize: 12 }}
                >
                  Sent
                </CustomText>
              ))}
          </>
        )}
      </>
    );
  };
  const getHeaderText = () => {
    let header = headerText.split("~~~");
    return (
      <>
        <CustomText bold={true} style={[styles.headText]}>
          {header[0] !== "" ? (
            <CustomText bold={true} style={[styles.headText, { color: "red" }]}>
              {header[0]}
            </CustomText>
          ) : (
            <></>
          )}
          {header[1]}
        </CustomText>
      </>
    );
  };
  const handleUserTypeChange = (name) => {
    let uType = { ...userType, [name]: !userType[name] };
    setUserType(uType);
  };
  const handleLogGAEventPasscode = (signDetails) => {
    try {
      handleAPI({
        name: "fnLogGAEvent_passcode",
        params: {
          UserWebloginId: signDetails["WebLoginId"],
          device: "mobile",
          LO: 0,
          fromAction: "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {
        console.log("fnLogGAEvent_passcode", response);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleLogAutoGAEventPasscode = (signDetails) => {
    try {
      handleAPI({
        name: "LogGAEvent",
        params: {
          UserWebloginId: signDetails["WebLoginId"],
          device: "mobile",
          LO: 0,
          fromAction: "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {
        console.log("LogGAEvent", response);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSaveUseType = () => {
    let { GatherId, ShortCode, firstName, lastName } = signUpDetails;

    handleAPI({
      name: "SaveUserType_WithOutLoan",
      params: {
        UserType: 1,
        WebLoginId: GatherId,
      },
    }).then((response) => {
      handleAPI({
        name: "CheckUserTypeSelected",
        params: {
          GatherId: GatherId,
          ShortCode: ShortCode,
        },
      }).then((UserTypeSelected) => {
        UserTypeSelected = JSON.parse(UserTypeSelected);

        if (parseInt(UserTypeSelected) === 1) {
          handleAPI({
            name: "CreateBorrowerLoginWithNoLoanId",
            params: {
              ShortCode: ShortCode,
              GatherId: GatherId,
            },
          }).then(async (response) => {
            response = response.split("~");
            let Loanid = response[1],
              WebLoginId = response[2],
              SessionId = response[3];
            let res = {
              ...signUpDetails,
              ...{
                Loanid: Loanid,
                WebLoginId: WebLoginId,
                SessionId: SessionId,
              },
            };
            setSignUpDetails(res);
            if (isRemember) {
              handleSetStoredCredential(res);
              handleLogAutoGAEventPasscode(res);
              handleAPI({
                name: "SaveDeviceFingerPrintWebForGatherId",
                params: {
                  GatherId: GatherId,
                  DeviceId: deviceId,
                  SaveResp: 1,
                },
              }).then((response) => {});
            } else {
              handleLogGAEventPasscode(res);
            }
            if (!SessionId) {
              SessionId = await handleCreateNewSession(WebLoginId);
            }
            let params = {
              userName: `${firstName} ${lastName}`,
              SessionId: SessionId,
            };
            if (loginType === "secureDoc") {
              handleSecureDocLogin(params);
            } else if (from == "startScreen") {
              if (Loanid <= 0) Loanid = -999;

              navigate("Home", {
                userName: userName,
                SessionId,
                loanId: Loanid,
              });
            } else navigate("DashBoard", params);

            setContextDetails((prevContextDetails) => {
              return {
                ...prevContextDetails,
                ...{
                  userName: `${firstName} ${lastName}`,
                  SessionId: SessionId,
                  Email: signUpDetails["email"] || "",
                },
              };
            });
            loginType !== "secureDoc" && handleClearState();
          });
        } else {
          let WebLoginId_Login = 0,
            SessionId_Login = "";
          Platform.OS === "web"
            ? handleOpenURL(
                `../../../Login/Presentation/Webforms/AccountSetupInformation.aspx?SessionID=${SessionId_Login}&WID=${WebLoginId_Login}&GatherId=${GatherId}&ShortCode=${ShortCode}`
              )
            : setWebPageURL(
                `../../../Login/Presentation/Webforms/AccountSetupInformation.aspx?SessionID=${SessionId_Login}&WID=${WebLoginId_Login}&GatherId=${GatherId}&ShortCode=${ShortCode}`
              );
          navigate("Login", { userName: userName });
          handleClearState();
        }
      });
    });
  };
  const handleSecureDocLogin = async (signDetails) => {
    setErrorMessage({
      color: "#999",
      text: (
        <View style={{ flexDirection: "row", paddingLeft: 10 }}>
          <View style={{ height: 25 }}>
            <ArrowSpinner size={15} />
          </View>
          <CustomText>
            {"  "}
            Processing...Please wait...
          </CustomText>
        </View>
      ),
      italic: false,
    });
    const { SessionId, userName } = signDetails;

    handleSelectLoan(0, SessionId, userName);
  };
  const handleSelectLoan = async (loanId, SessionId, userName) => {
    if (loanId == 0) {
      setErrorMessage({
        ...{
          color: "#999",
          text: (
            <View style={{ flexDirection: "row", paddingLeft: 10 }}>
              <View style={{ height: 25 }}>
                <ArrowSpinner size={15} />
              </View>
              <CustomText>
                {"  "}
                Loan Creation is in progress. Please wait...
              </CustomText>
            </View>
          ),
          italic: false,
        },
      });

      await handleAPI({
        name: "CreateLoanOnly",
        params: { sessionid: SessionId, empid: 1, EventId: 15 },
      })
        .then((response) => {
          loanId = JSON.parse(response);
          console.log("loanId", loanId);
          if (loanId != 0) {
            try {
              handleAPI({
                name: "AssociateLoanId_GA",
                params: {
                  SessionId,
                  LoanId: loanId,
                  LoginMethod: "UploadDocs",
                },
              })
                .then((response) => {
                  log("response", response);
                })
                .catch((e) => log("Error from AssociateLoanId_GA ====>", e));
            } catch (error) {}
          }
        })
        .catch((error) => log("Error from CreateLoanOnly ====> ", error));
    }

    navigate("Home", {
      userName: userName,
      SessionId,
      loanId,
      GoToNav: 9,
    });
    handleClearState();
  };
  const handleStoreCampaignDetails = () => {
    try {
      handleAPI({
        name: "StoreUTMCampaignWithOutLoginId",
        params: {
          CampignId: "118",
          WebLoginId: signUpDetails["WebLoginId"] || 4142,
          utmsource: "Direct Mortgage",
          utmmedium: "Internal",
          utmcampaign: "Login Creation",
          utmcontent: "",
          utmterm: "",
          OrgUrl: `${REDIRECT_URL}sitelogin`,
          MsgText: "",
          Email: signUpDetails["email"],
          Phone: signUpDetails["cellPhone"],
          CampignNum: 0,
          LeadOfficer: 0,
        },
      }).then((response) => {
        console.log("StoreUTMCampaignWithOutLoginId", response);
      });
    } catch (e) {
      console.error(e);
    }
  };
  const keyboardHeight = ios ? useKeyboardHeight() || 30 : 0;
  //========================================
  return (
    <>
      {webPageURL ? (
        <>
          <webPageView url={webPageURL} />
        </>
      ) : (
        <View style={{ backgroundColor: "#fff", flex: 1 }}>
          <View style={{ maxWidth: 600 }}>
            {from != "startScreen" && <DMCImage />}
            <ScrollContainer>
              <View
                style={[
                  styles.container,
                  {
                    marginBottom: keyboardHeight,
                  },
                ]}
              >
                <View style={styles.headContainer}>{getHeaderText()}</View>
                <View style={styles.body}>
                  {currentPage === "signUp" && (
                    <>
                      <InputBox
                        label="First Name"
                        placeholder="First Name"
                        onChangeText={(text) =>
                          handleChange({ name: "firstName", value: text })
                        }
                        autoFocus
                        value={signUpDetails["firstName"]}
                        validate={validateSignUp["firstName"]}
                      />
                      <InputBox
                        label="Last Name"
                        placeholder="Last Name"
                        onChangeText={(text) =>
                          handleChange({ name: "lastName", value: text })
                        }
                        value={signUpDetails["lastName"]}
                        validate={validateSignUp["lastName"]}
                      />
                      <InputBox
                        keyboardType="numeric"
                        label="Cell Phone Number"
                        placeholder="Cell Phone Number"
                        onChangeText={(text) =>
                          handleChange({ name: "cellPhone", value: text })
                        }
                        onBlur={() => {
                          handleChange({
                            name: "formatedCellPhone",
                            value: signUpDetails["cellPhone"],
                            isFormat: true,
                          });
                        }}
                        value={signUpDetails["formatedCellPhone"]}
                        validate={validateSignUp["cellPhone"]}
                      />
                      <InputBox
                        label="Email Address"
                        placeholder="Email address"
                        onChangeText={(text) =>
                          handleChange({ name: "email", value: text })
                        }
                        value={signUpDetails["email"]}
                        validate={validateSignUp["email"]}
                      />
                      {errorMsg["text"] && (
                        <View>
                          <CustomText
                            bold={true}
                            style={{
                              color: errorMsg["color"] || "red",
                              fontSize: 15,
                              marginTop: 15,
                            }}
                          >
                            {errorMsg["text"]}
                          </CustomText>
                        </View>
                      )}
                      <IconButton
                        title="Submit"
                        onPress={handleSubmit}
                        style={{
                          alignSelf: "flex-end",
                        }}
                        loading={processingStatus === "Submit"}
                        sStyle={{
                          minWidth: 30,
                          height: 15,
                          top: 8,
                        }}
                      />
                    </>
                  )}
                  {currentPage === "accessCode" && (
                    <>
                      <InputBox
                        label="Access Code"
                        autoFocus
                        keyboardType="numeric"
                        placeholder="Please enter your access code..."
                        onChangeText={(text) => {
                          handleChange({
                            name: "enteredAccessCode",
                            value: text,
                          });
                          if (errorMsg["text"] !== "")
                            setErrorMsg({ ...errorMsg, text: "" });
                        }}
                        value={signUpDetails["enteredAccessCode"]}
                      />
                      {errorMsg["text"] && (
                        <View>
                          <CustomText
                            bold={true}
                            style={{
                              color: errorMsg["color"] || "red",
                              fontSize: 15,
                              marginTop: -5,
                              marginBottom: 15,
                            }}
                          >
                            {errorMsg["text"]}
                          </CustomText>
                        </View>
                      )}
                      <View
                        style={{
                          flexDirection: "row",
                          flex: 3,
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            flex: 1.9,
                            alignItems: "flex-end",
                          }}
                        >
                          <Checkbox
                            value={isRemember}
                            onValueChange={() => {
                              setIsRemember(!isRemember);
                            }}
                            color={isRemember ? "#0075ff" : undefined}
                          />
                          <View style={{ flexDirection: "column" }}>
                            <CustomText
                              bold={true}
                              style={{
                                color: "#999",
                                fontSize: 13,
                                marginLeft: 5,
                              }}
                              onPress={() => {
                                setIsRemember(!isRemember);
                              }}
                            >
                              Remember me on this device
                            </CustomText>
                          </View>
                        </View>
                        <View
                          style={{
                            flex: 1.1,
                          }}
                        >
                          <IconButton
                            siz
                            style={{
                              alignSelf: "flex-end",
                            }}
                            loading={processingStatus === "validating"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                              top: 8,
                            }}
                            onPress={() => {
                              setProcessingStatus("validating");
                              log("signUpDetails", signUpDetails);
                              setAccesscodeWarningMsg("");
                              if (
                                signUpDetails["AccessCode"] ===
                                signUpDetails["enteredAccessCode"]
                              ) {
                                setHeaderText(
                                  "~~~Set a password or skip and login."
                                );
                                setCurrentPage("loginOption");
                                setProcessingStatus(null);
                                handleStoreCampaignDetails();
                              } else {
                                setProcessingStatus(null);
                                setErrorMsg({
                                  ...errorMsg,
                                  text: "Invalid Access Code.",
                                });
                              }
                            }}
                            title="Validate Code"
                          />
                        </View>
                      </View>
                      <View style={{ marginVertical: 10, marginHorizontal: 0 }}>
                        <View
                          style={{
                            borderBottomColor: "black",
                            borderBottomWidth: 1,
                            marginTop: 10,
                          }}
                        />
                        <View
                          style={{
                            marginTop: 10,
                            marginBottom: 20,
                          }}
                        >
                          {accesscodeWarningMsg && (
                            <CustomText
                              style={{
                                fontSize: 16,
                                color: "#999",
                                marginBottom: 15,
                                marginTop: -15,
                              }}
                              bold={true}
                            >
                              {accesscodeWarningMsg}
                            </CustomText>
                          )}
                          <CustomText
                            style={{
                              fontSize: 17,
                              color: "#999",
                              marginBottom: 15,
                            }}
                            bold={true}
                          >
                            Didn't get the code?
                          </CustomText>
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <View>{getSecureEmail()}</View>
                            <View>{getSecurePhone()}</View>
                          </View>
                        </View>
                      </View>
                    </>
                  )}
                  {currentPage === "loginOption" && (
                    <>
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <View style={{ flexDirection: "row" }}>
                          <IconButton
                            loading={processingStatus === "loginNow"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                              top: 8,
                            }}
                            onPress={() => {
                              setProcessingStatus("loginNow");
                              handleSaveUseType(false, signUpDetails, true);
                            }}
                            title="Login Now"
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <IconButton
                            loading={processingStatus === "setPassword"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                              top: 8,
                            }}
                            style={{ marginLeft: 10 }}
                            onPress={() => {
                              setHeaderText("~~~Set a password");
                              setCurrentPage("setPassword");
                            }}
                            title="Set Password"
                            buttonType="secondary"
                          />
                        </View>
                      </View>
                    </>
                  )}
                  {currentPage === "setPassword" && (
                    <View>
                      <CustomText
                        bold={true}
                        style={{
                          fontSize: 14,
                          color: "#999",
                          marginBottom: 25,
                        }}
                      >
                        {`Please create your password below: 

Password Requirments: 
Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as:
(@!*&).`}
                      </CustomText>
                      <View>
                        <View>
                          <InputBox
                            label="Password"
                            autoFocus
                            secureTextEntry={newIsPasswordSecure["password"]}
                            placeholder="Please enter your password..."
                            onChangeText={(text) => {
                              validatePassword("password", text);
                            }}
                            value={newPassword["password"]}
                          />

                          <CustomText
                            style={{ position: "absolute", right: 20, top: 15 }}
                            onPress={() => {
                              setNewIsPasswordSecure({
                                ...newIsPasswordSecure,
                                password: !newIsPasswordSecure["password"],
                              });
                            }}
                          >
                            {newIsPasswordSecure["password"] ? (
                              <FontAwesome name="eye" color="gray" size={25} />
                            ) : (
                              <FontAwesome
                                name="eye-slash"
                                color="gray"
                                size={25}
                              />
                            )}
                          </CustomText>

                          {newPasswordMessage["passwordMsg"] !== "" &&
                            newPassword["password"] !== "" && (
                              <>{newPasswordMessage["passwordMsg"]}</>
                            )}
                        </View>
                        <View>
                          <InputBox
                            label="Confirm Password"
                            secureTextEntry={
                              newIsPasswordSecure["confirmPassword"]
                            }
                            placeholder="Confirm your password..."
                            onChangeText={(text) => {
                              validatePassword("confirmPassword", text);
                            }}
                            value={newPassword["confirmPassword"]}
                          />
                          <CustomText
                            style={{ position: "absolute", right: 20, top: 15 }}
                            onPress={() => {
                              setNewIsPasswordSecure({
                                ...newIsPasswordSecure,
                                confirmPassword:
                                  !newIsPasswordSecure["confirmPassword"],
                              });
                            }}
                          >
                            {newIsPasswordSecure["confirmPassword"] ? (
                              <FontAwesome name="eye" color="gray" size={25} />
                            ) : (
                              <FontAwesome
                                name="eye-slash"
                                color="gray"
                                size={25}
                              />
                            )}
                          </CustomText>

                          {newPasswordMessage["confirmPasswordMsg"] !== "" &&
                            newPassword["confirmPassword"] !== "" && (
                              <>{newPasswordMessage["confirmPasswordMsg"]}</>
                            )}
                        </View>
                        <View style={{ marginBottom: 20 }}>
                          <IconButton
                            loading={processingStatus === "Save&Login"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                              top: 8,
                            }}
                            onPress={() => {
                              if (newPassword["password"] === "") {
                                setPasswordMisMatch(
                                  "Please enter the New Password."
                                );
                                return false;
                              }
                              if (newPassword["confirmPassword"] === "") {
                                setPasswordMisMatch(
                                  "Please enter the Confirm New Password."
                                );
                                return false;
                              }
                              if (
                                newPassword["confirmPassword"] !==
                                newPassword["password"]
                              ) {
                                setPasswordMisMatch(
                                  "The new password and confirmed password do not match."
                                );
                                return false;
                              }

                              let strength = 0,
                                text = newPassword["password"];
                              if (text.length > 6) strength += 1;
                              if (
                                text.match(/([A-Z])/) &&
                                text.match(/([0-9])/)
                              )
                                strength += 1;
                              if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/))
                                strength += 1;
                              if (strength < 3) {
                                setPasswordMisMatch(
                                  `Password does not meet minimum complexity requirements, password must contain: 
  Minimum length of 6 characters 
  Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                );
                                return false;
                              }
                              strength = 0;
                              text = newPassword["confirmPassword"];
                              if (text.length > 6) strength += 1;
                              if (
                                text.match(/([A-Z])/) &&
                                text.match(/([0-9])/)
                              )
                                strength += 1;
                              if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/))
                                strength += 1;
                              if (strength < 3) {
                                setPasswordMisMatch(
                                  `Password does not meet minimum complexity requirements, password must contain: 
  Minimum length of 6 characters 
  Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                );
                                return false;
                              }

                              if (
                                newPassword["password"] ===
                                newPassword["confirmPassword"]
                              ) {
                                setProcessingStatus("Save&Login");
                                let { GatherId, email, ShortCode } =
                                  signUpDetails;
                                handleAPI({
                                  name: "UpdatePasswordinGatherdata",
                                  params: {
                                    GatherId: GatherId,
                                    UserName: email,
                                    Password: newPassword["password"],
                                    // shortCode: ShortCode,
                                  },
                                })
                                  .then((response) => {
                                    // setHeaderText(
                                    //   "~~~Please select the type of user account that you will be using:"
                                    // );
                                    // setCurrentPage("userType");
                                    handleSaveUseType();
                                  })
                                  .catch((err) =>
                                    console.log(
                                      "Error from ====> UpdatePasswordinGatherdata",
                                      err
                                    )
                                  );
                              }
                            }}
                            title="Save & Login"
                          />
                        </View>

                        {PasswordMisMatch !== "" && (
                          <View
                            style={{
                              backgroundColor: "#f2dede",
                              borderColor: "#ebccd1",
                              borderRadius: 4,
                              borderWidth: 1,
                              padding: 10,
                              marginTop: 10,
                            }}
                          >
                            <CustomText bold={true} style={{ color: "#999" }}>
                              {PasswordMisMatch}
                            </CustomText>
                          </View>
                        )}
                      </View>
                    </View>
                  )}
                  {currentPage === "userType" && (
                    <>
                      <View>
                        <View>
                          <View style={{ width: "80%" }}>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("mortgageEmployee");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["mortgageEmployee"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                Mortgage Employee
                              </CustomText>
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("borrower");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["borrower"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                Borrower
                              </CustomText>
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleUserTypeChange("vendor");
                              }}
                              style={styles.optionContainer}
                            >
                              {userType["vendor"] && (
                                <FontAwesome
                                  name="check"
                                  size={22}
                                  color="green"
                                />
                              )}
                              <CustomText bold={true} style={styles.optionText}>
                                Vendor
                              </CustomText>
                            </TouchableOpacity>
                          </View>
                        </View>
                        <IconButton
                          onPress={() => {
                            handleSaveUseType();
                          }}
                          title="Continue"
                        />
                      </View>
                    </>
                  )}
                  {errorMessage["text"] !== "" && (
                    <CustomText
                      bold={true}
                      italic={
                        errorMessage["italic"] === undefined ? true : false
                      }
                      style={[
                        styles.errorMessage,
                        {
                          color: errorMessage["color"] || "red",
                          marginTop: -5,
                          marginBottom: 0,
                        },
                      ]}
                    >
                      {errorMessage["text"]}
                    </CustomText>
                  )}
                </View>
                <View style={styles.footContainer}>
                  <CustomText
                    bold={true}
                    onPress={(e) => {
                      navigate("Login", { reset: true });
                    }}
                    style={[
                      styles.footText,
                      { textDecorationLine: "none", borderWidth: 0 },
                    ]}
                  >
                    <Icon name="arrowleft" size={15} color="#999" />
                    Back
                  </CustomText>
                  {currentPage === "emailOnly" && (
                    <CustomText
                      bold={true}
                      onPress={(e) => {
                        navigate("Login", { reset: true });
                      }}
                      style={styles.footText}
                    >
                      Forgot Password
                    </CustomText>
                  )}
                </View>
              </View>
            </ScrollContainer>
          </View>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    color: "#333",
    backgroundColor: "#f5f5f5",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    margin: 5,
    // marginBottom: 150,
  },

  optionContainer: {
    // elevation: 8,
    borderRadius: 15,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderColor: "#606060",
    borderWidth: 1,
    marginBottom: 20,
    flexDirection: "row",
  },
  optionText: {
    width: "100%",
    color: "#999",
    fontSize: 23,
    textAlign: "center",
    flex: 1,
    flexShrink: 1,
  },
  body: {
    display: "flex",
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#ddd",
    paddingTop: 25,
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  textBox: {
    width: "90%",
    // height: 65,
    flexDirection: "row",
    marginLeft: 10,
    fontSize: 5,
  },
  footContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
  },
  headContainer: {
    marginTop: 5,
    marginBottom: 10,
    paddingVertical: 10,
    paddingHorizontal: 15,
  },

  footText: {
    fontSize: 13,
    color: "#999",
    textDecorationLine: Platform.OS === "android" ? "none" : "underline",
    borderBottomWidth: Platform.OS === "android" ? 1 : 0,
    borderBottomColor: "#999",
  },
  headText: {
    fontSize: 17,
    color: "#999",
  },
});
